export const checkOpenedIdAndPreloadData = ({
  openedId,
  preload,
}: {
  openedId?: string | number | null;
  preload?: string;
}) => {
  if (!preload) return !!openedId;

  try {
    JSON.parse(preload);
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('SDUI error preload params', e);
    return false;
  }
};
